import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export function SendEmailButton({ userId, fullName, email }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.stopPropagation();
    if (!userId) return;
    const params = new URLSearchParams({ to: userId });
    if (fullName) params.set('name', fullName);
    if (email) params.set('email', email);
    navigate(`/email-studio?${params.toString()}`);
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={handleClick}
          className="inline-flex items-center justify-center h-6 w-6 rounded hover:bg-accent transition-colors"
        >
          <Mail className="h-3.5 w-3.5 text-muted-foreground hover:text-foreground" />
        </button>
      </TooltipTrigger>
      <TooltipContent>Send email</TooltipContent>
    </Tooltip>
  );
}
